import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import GreyArrow from "../assets/greyLeftAr.png";
import { Modal } from "react-bootstrap";
import {
  X,
  ChevronLeft,
  ChevronRight,
  Info,
  Wrench,
  ArrowLeft,
  FileText,
  Camera,
} from "lucide-react";
import { goBack } from "../CommonJquery/CommonJquery.js";
import { Button } from "@mui/material";
import { APL_LINK } from "../ServiceConnection/serviceconnection";

export default function ViewRepair() {
  const location = useLocation();
  const { data, ImageLink } = location.state || {};
  const RepairData = data;
  console.log("RepairData", RepairData);

  // Dummy data for design demonstration
  const dummyRepairData = {
    repair_reason: "Engine Overheating",
    assign_staff_name: "John Smith",
    name_and_issue: "Toyota Camry - Coolant leak causing overheating",
    odometer_reading: "85,432",
    odometer_image: "odometer_sample.jpg",
    vehicle_image1: "vehicle_front.jpg",
    vehicle_image2: "vehicle_back.jpg",
    vehicle_image3: "vehicle_left.jpg",
    vehicle_image4: "vehicle_right.jpg",
    damage_status: "someDamage",
    damage_image1: "damage_front_bumper.jpg",
    damage_image2: "damage_side_panel.jpg",
    damage_image3: "damage_rear_light.jpg",
    damage_image4: "damage_interior.jpg",
    repair_notes:
      "Replaced radiator hose and refilled coolant. Minor scratches on front bumper need attention. Vehicle tested and running normally.",
    damage_charges: "250.00",
  };

  // Use dummy data if no real data is provided (for design purposes)
  const displayData = RepairData || dummyRepairData;

  // Modal state for image viewing
  const [showModal, setShowModal] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [ImAgeShowlist, setImAgeShowlist] = useState([]);

  const openModal = (image, index) => {
    setCurrentIndex(index);
    setImAgeShowlist(image);
    setShowModal(true);
  };

  const closeModal = () => setShowModal(false);

  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % ImAgeShowlist.length);
  };

  const prevImage = () => {
    setCurrentIndex(
      (prevIndex) =>
        (prevIndex - 1 + ImAgeShowlist.length) % ImAgeShowlist.length
    );
  };

  // General Info Section
  const generalInfoSection = () => {
    return (
      <div className="check-section mb-4">
        <div className="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 className="section-title">
            <Info size={18} className="iconViewMaintn" /> General Info
          </h3>
        </div>
        <div className="section-content card">
          <div className="card-body">
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Reason</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                {/* <span className="field-value">{displayData.repair_reason}</span> */}
                <span className="field-value">Repair</span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Done By</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{displayData.assign_staff_name}</span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Issue with the car
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{displayData.name_and_issue}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Repair Step 1 Section
  const repairStep1Section = () => {
    return (
      <div className="check-section mb-4">
        <div className="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 className="section-title">
            <Wrench size={18} className="iconViewMaintn" /> Repair Step 1
          </h3>
        </div>
        <div className="section-content card">
          <div className="card-body">
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Odometer Reading
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{displayData.odo_metter}</span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Odometer Image
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  <img
                    src={APL_LINK + ImageLink + displayData.odo_image}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                    className="step_8_img_view"
                    alt="Odometer"
                  />
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Vehicle Images
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <div className="code_img_cntr">
                  {(() => {
                    // const imageArray = [1, 2, 3, 4]
                    //   .map((i) => displayData[`corner_image${i}`])
                    //   .filter((url) => url);
                    const imageArray =
                      displayData.corner_image?.split("@@@").filter(Boolean) ||
                      [];

                    return imageArray.map((imageUrl, i) => (
                      <div
                        className="col-3"
                        style={{ marginRight: "10px" }}
                        key={i}
                      >
                        <img
                          src={APL_LINK + ImageLink + imageUrl}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                          alt={`Vehicle Image ${i + 1}`}
                          className="Img_contr_code_main"
                          onClick={() => openModal(imageArray, i)}
                          style={{ marginRight: "10px" }}
                        />
                      </div>
                    ));
                  })()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Repair Step 2 Section
  const repairStep2Section = () => {
    return (
      <div className="check-section mb-4">
        <div className="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 className="section-title">
            <Camera size={18} className="iconViewMaintn" /> Repair Step 2
          </h3>
        </div>
        <div className="section-content card">
          <div className="card-body">
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Damage Images</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <div className="code_img_cntr">
                  {(() => {
                    const imageArray =
                      displayData.damage_image?.split("@@@").filter(Boolean) ||
                      [];
                    return imageArray.map((imageUrl, i) => (
                      <div
                        className="col-3"
                        style={{ marginRight: "10px" }}
                        key={i}
                      >
                        <img
                          src={APL_LINK + ImageLink + imageUrl}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                          alt={`Damage Image ${i + 1}`}
                          className="Img_contr_code_main"
                          onClick={() => openModal(imageArray, i)}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    ));
                  })()}
                </div>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Notes</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{displayData.notes_for_future}</span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Damage Charges
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  ${displayData.damage_amount_box}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <Header />
      <div className="container-lg">
        <div className="pageCntn_head">
          <div className="pageNameDiv">
            <div className="d-flex gap-2 align-items-center">
              <p>View Repair Details</p>
              <img
                src={GreyArrow}
                alt="Rapid Car Leasing"
                style={{ height: "14px" }}
              />
            </div>
          </div>
          <Button
            onClick={goBack}
            startIcon={<ArrowLeft size={17} style={{ marginBottom: "2px" }} />}
            className="Back_bttn_page"
          >
            Back
          </Button>
        </div>
      </div>

      <div className="container-lg">
        <div className="final-checks-container2">
          <div className="row">
            <div className="col-md-6">
              {generalInfoSection()}
              {repairStep1Section()}
            </div>
            <div className="col-md-6">{repairStep2Section()}</div>
          </div>
        </div>
      </div>

      <Modal
        className="code_reading_modal"
        show={showModal}
        onHide={closeModal}
        centered
      >
        <Modal.Body className="text-center position-relative">
          <X size={24} className="close_bttn_mdl" onClick={closeModal} />
          <div className="left_right_bttns">
            <button type="button" className="left_img" onClick={prevImage}>
              <ChevronLeft size={30} />
            </button>
            <button type="button" className="right_img" onClick={nextImage}>
              <ChevronRight size={30} />
            </button>
          </div>

          <img
            src={APL_LINK + ImageLink + ImAgeShowlist[currentIndex]}
            alt="Selected"
            className="img-fluid modal-img coade_iMg"
          />
        </Modal.Body>
      </Modal>
    </div>
  );
}
